import React, { useState } from "react";

const ViewIsokinetic = ({ stepData }: any) => {

    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Isokinetic</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Test Speed</th>
                                            <th>Parameter Name</th>
                                            <th>Percentage Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepData.isokinetic.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>{row.test_speed}</td>
                                                <td>{row.parameter_name}</td>
                                                <td>{row.percentage_value}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewIsokinetic;